import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import RouteLoader from "./Components/RouteLoader";

import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Products from "./Pages/Products/Products";
import ProductDetail from "./Pages/Products/ProductDetail";
import CartDrawer from "./Components/CartDrawer";
import PaymentSuccess from "./Pages/PaymentSuccess";
import SignupPage from "./Pages/Signup/SignupPage";
import SignupDetailsPage from "./Pages/Signup/SignupDetailsPage";
import LoginPage from "./Pages/LoginPage";
import MyOrders from "./Pages/MyOrders";
import MyAccount from "./Pages/MyAccount";
import EditAccountDetails from "./Pages/EditAccountDetails";
import OrderDetails from "./Pages/OrderDetails";

import TermsOfUse from "./Pages/Legal/TermsOfUse";
import PrivacyPolicy from "./Pages/Legal/PrivacyPolicy";
import ShippingPolicy from "./Pages/Legal/ShippingPolicy";
import RefundPolicy from "./Pages/Legal/RefundPolicy";

import { CartProvider } from "./cart/CartContext";
import { AuthProvider } from "./auth/AuthContext";
import ScrollToTop from "./Components/ScrollToTop";


// Toastify
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <Router>
      <AuthProvider>
        <CartProvider>
          {/* ⭐ Loader קטן לכל ניווט בין עמודים */}
          <RouteLoader />
<ScrollToTop />
          <Navbar />

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/products" element={<Products />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/cart" element={<CartDrawer />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/signup-details" element={<SignupDetailsPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/shipping-policy" element={<ShippingPolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/my-orders" element={<MyOrders />} />
            <Route path="/my-account" element={<MyAccount />} />
            <Route path="/edit-account" element={<EditAccountDetails />} />
            <Route path="/order/:orderId" element={<OrderDetails />} />
          </Routes>

          <Footer />

          <ToastContainer position="top-center" autoClose={3000} />
        </CartProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
